var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',[_vm._v(" Über die Schreibtisch-Ansicht werden Sie zu einem späteren Zeitpunkt freien Zugriff auf sämtliche im Projekt erarbeiteten Ressourcen erhalten. ")])])
}]

export { render, staticRenderFns }